import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from './managed-applications.reducer';
import { ManagedApplicationsState, createManagedApplicationId } from './managed-applications.state';

export const selectManagedApplicationsState = createFeatureSelector<ManagedApplicationsState>(
  fromReducer.mdmManagedAppliationsFeatureKey
);

export const selectManagedApplicationsIds = createSelector(
  selectManagedApplicationsState,
  fromReducer.selectManagedApplicationsIds
);

export const selectManagedApplicationsEntities = createSelector(
  selectManagedApplicationsState,
  fromReducer.selectManagedApplicationsEntities
);

export const selectManagedApplicationsByUdid = (udid: string) =>
  createSelector(
    selectManagedApplicationsEntities,
    selectManagedApplicationsIds,
    (managedApplications, ids) =>
      (ids as string[]) && (ids as string[]).filter((id) => id.startsWith(udid)).map((id) => managedApplications[id])
  );

export const selectManagedApplicationsByUdidAndIdentifier = (udid: string, identifier: string) =>
  createSelector(
    selectManagedApplicationsEntities,
    (managedApplications) => managedApplications[createManagedApplicationId(udid, identifier)]
  );
